import PropTypes from 'prop-types'
import { gql } from '@apollo/client'
import { eventListFragment, eventListFragmentPropTypes } from '~/graphql/fragments/eventList'

const groupFragment = gql`
  fragment group on Group {
    id
    subtitle
    title
    imageBackgroundUrl
    imageThumbnailUrl
    logoUrl
    items(first: 100) {
      edges {
        node {
          ...eventList
        }
      }
    }
  }

  ${eventListFragment}
`

export const groupFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  imageBackgroundUrl: PropTypes.string,
  imageThumbnailUrl: PropTypes.string,
  logoUrl: PropTypes.string,
  items: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.shape({
          eventListFragmentPropTypes,
        }),
      })
    ),
  }),
})

export default groupFragment
